export const bestSellers = [
    { title: "Jeera", url: "images/jeera.jpg", value:10, quantity:0  },
    { title: "Fruit Beer", url: "images/fruitBeer.jpg", value:10, quantity:0  },
    { title: "Blueberry", url: "images/blueberry.jpg", value:10, quantity:0  },
    { title: "Sweet Limbo", url: "images/15/sweetlemon.jpg", value:15, quantity:0  },
  ];
export const sodas = [
    { title: "Mango", url: "images/mango.jpg", value: 10, quantity:0 },
    { title: "Limca", url: "images/limca.jpg", value: 10, quantity:0 },
    { title: "Kala Khatta", url: "images/kalaKhatta.jpg", value: 10, quantity:0 },
    { title: "Orange ", url: "images/orange.jpg", value: 10, quantity:0 },
    { title: "Pudina ", url: "images/pudina.jpg", value: 10, quantity:0 },
    { title: "Jeera", url: "images/jeera.jpg", value: 10, quantity:0 },
    { title: "Fruit Beer", url: "images/fruitBeer.jpg", value: 10, quantity:0 },
    { title: "Blueberry", url: "images/blueberry.jpg", value: 10, quantity:0 },
    { title: "Lemon ", url: "images/lemon.jpg", value: 10, quantity:0 },
    { title: "Strawberry ", url: "images/strawberry.jpg", value: 10, quantity:0 },
    { title: "Cola", url: "images/cola.jpg", value: 10, quantity:0 },
    { title: "Limbo Masala", url: "images/15/masala.jpg", value: 15, quantity:0 },
    { title: "Sweet Limbo", url: "images/15/sweetlemon.jpg", value: 15, quantity:0 },
    { title: "Salty Limbo", url: "images/15/saltyLemon.jpg", value: 15, quantity:0 },
    { title: "Ginger Limbo", url: "images/15/ginger.jpg", value: 15, quantity:0 },
    { title: "Nimbu Sharbat", url: "images/15/nimbuSharbat.jpg", value: 15, quantity:0 },
  ];


